export const WINEFO_URL = 'https://www.winefo.eu';
export const WINEFO_BLOG = 'https://www.Winefo.eu/blog';
